/**
 * True while any of the driver view's queries has not produced a result.
 *
 * Store queries compute synchronously, so with complete params a `null` result only occurs for
 * the one render before the first compute; missing params mean the queries are disabled
 * (`enabled` guards), not loading. This mirrors the exact guard the Driver repository queries use
 * (`!workspaceId || !membershipId`); if those guards ever grow another condition, this predicate
 * must grow with them.
 */
export function isInitialDriverLoadPending({
  workspaceId,
  membershipId,
  results,
}: {
  workspaceId: string;
  membershipId: string | undefined;
  results: readonly unknown[];
}): boolean {
  if (!workspaceId || !membershipId) return false;
  return results.some((result) => result === null);
}
